export function getCurrentUrl(pathname: string) {
  return pathname.split(/[?#]/)[0]
}

export function checkIsActive(pathname: string, url: string) {
  if (!pathname || !url) {
    return false
  }

  const current = getCurrentUrl(pathname)
  const target = getCurrentUrl(url)

  if (current === target) {
    return true
  }

  if (target === '/') {
    return true
  }

  const normalizedTarget = target.endsWith('/') ? target : `${target}/`
  if (current.startsWith(normalizedTarget)) {
    return true
  }

  return false
}
